// extracted by mini-css-extract-plugin
export default {"selector":"EmployeeMenu_selector__uYoin","menu":"EmployeeMenu_menu__6NXRn","customDivider":"EmployeeMenu_customDivider__Ttl0x"};